import type { ExperienceManifest } from '../../types'

export const manifest: ExperienceManifest = {
  version: '1.0.0',
  schemaVersion: '1.0.0',
  minimumFrameworkVersion: '1.0.0',
  capabilities: {
    supportsAudio: false,
    supportsInteraction: true,
    supportsReplay: true,
    supportsReducedMotion: true,
    supportsLocalization: false,
    supportsAnalytics: true,
    supportsCelebration: false,
  },
  metadata: {
    id: 'clock',
    name: 'Monolithic Clock',
    description: 'A dynamic visual clock tracking the percentage of the current day completed.',
    category: 'entrance',
    themePreference: 'both',
  },
  eligibility: {
    check: () => true, // Available at all times
    cooldownMs: 4 * 60 * 60 * 1000,
    basePriority: 50,
  },
  ComponentLoader: () => import('./component'),
  preload: async () => Promise.resolve(),
}

export default manifest
